import Http from "./base-http";
class ApplyAvailabilityTemplate extends Http {
  addAvailabilityTemplate(data) {
    return this.client.post(`/${data.userId}/applyAvailabilityTemplate/${data.availabilityId}`)
  }
}

const applyAvailabilityTemplateObj = new ApplyAvailabilityTemplate({
  modelUrlPrefix : "process/User"
});

export default applyAvailabilityTemplateObj;
